(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcessedPatientResult', ProcessedPatientResult);

    ProcessedPatientResult.$inject = ['$resource', 'DataUtils'];

    function ProcessedPatientResult ($resource, DataUtils) {
        var resourceUrl =  'api/processed-patient-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/processed-patient-results/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'download': {
                url: 'api/processed-patient-results/download/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            }
        });
    }
})();
